<template>
  <div class="page">
    <div class="banner-wrapper">
      <img class="banner" src="./images/img_82837_0_17.png" />
    </div>
    ,
    <div class="list">
      <img class="floor-bg" src="./images/img_82837_0_19.png" />

      <div v-for="(item, i) in section1" @click="goDetail(item)" :key="i" class="header-i0">
        <img
          v-if="i === 0"
          class="action-bg"
          src="./images/img_82837_0_20.png"
        />
        <img
          v-if="i === 1"
          class="action-bg"
          src="./images/img_82837_0_25.png"
        />
        <img
          v-if="i === 2"
          class="action-bg"
          src="./images/img_82837_0_30.png"
        />
        <div class="wrapper">
          <div class="wrapper-inner">
            <div class="group">
              <div class="background-wrapper">
                <img class="layer" src="./images/img_82837_0_38.png" />
                <img class="background" :src="item.web_thumb" />
              </div>
              <img class="entry-pic" src="./images/img_82837_0_23.png" />
            </div>
            <div class="button-wrapper"><span class="button">{{ item.describes[1] }}</span></div>
          </div>
          <div class="wrapper-inner-1">
            <span class="title">{{ item.title }}</span>
            <span class="caption"
              >{{ item.describes[0] }}</span
            >
            <img class="button-bg" src="./images/img_82837_0_24.png" />
          </div>
        </div>
      </div>

      <img class="long-bg" src="./images/img_82837_0_18.png" />

      <img class="bar" src="./images/img_82837_0_36.png" />
      
      <div v-for="(item, i) in section2" @click="goDetail(item)" :key="i + '2'" class="header-i3">
        <img
          v-if="i === 0"
          class="action-bg"
          src="./images/img_82837_0_37.png"
        />
        <img
          v-if="i === 1"
          class="action-bg"
          src="./images/img_82837_0_42.png"
        />
        <img
          v-if="i === 2"
          class="action-bg"
          src="./images/img_82837_0_47.png"
        />
        <div class="wrapper-3">
          <div class="wrapper-inner-6">
            <div class="group-3">
              <div class="background-wrapper-3">
                <img class="layer-3" src="./images/img_82837_0_38.png" />
                <img class="background-3" :src="item.web_thumb" />
              </div>
              <img class="entry-pic-3" src="./images/img_82837_0_40.png" />
            </div>
            <div class="btn-wrapper-1">
              <span class="btn-1">{{ item.describes[1] }}</span>
            </div>
          </div>
          <div class="wrapper-inner-7">
            <span class="title-3">{{ item.title }}</span>
            <span class="caption-3"
              >{{ item.describes[0] }}</span
            >
            <img class="button-bg-3" src="./images/img_82837_0_41.png" />
          </div>
        </div>
      </div>

      <img class="atmosphere" src="./images/img_82837_0_35.png" />

      <img class="floor-bg-1" src="./images/img_82837_0_53.png" />

      <div v-for="(item, i) in section3" @click="goDetail(item)" :key="i + '3'" class="row-i2">
        <img
          v-if="i === 0"
          class="action-bg"
          src="./images/img_82837_0_54.png"
        />
        <img
          v-if="i === 1"
          class="action-bg"
          src="./images/img_82837_0_59.png"
        />

        <div class="wrapper-6">
          <div class="wrapper-inner-12">
            <div class="group-6">
              <div class="background-wrapper-6">
                <img class="layer-6" src="./images/img_82837_0_38.png" />
                <img class="background-6" :src="item.web_thumb" />
              </div>
              <img class="entry-pic-6" src="./images/img_82837_0_57.png" />
            </div>
            <div class="button-wrapper-3">
              <span class="button-3">{{ item.describes[1] }}</span>
            </div>
          </div>
          <div class="wrapper-inner-13">
            <span class="title-6">{{ item.title }}</span>
            <span class="caption-6"
              >{{ item.describes[0] }}</span
            >
            <img class="button-bg-6" src="./images/img_82837_0_58.png" />
          </div>
        </div>
      </div>

      <img class="long-bg-1" src="./images/img_82837_0_52.png" />
      <img class="bar-1" src="./images/img_82837_0_0.png" />

      <div v-for="(item, i) in section4" @click="goDetail(item)" :key="i + '4'" class="row-i4">
        <img
          v-if="i === 0"
          class="action-bg"
          src="./images/img_82837_0_1.png"
        />
        <img
          v-if="i === 1"
          class="action-bg"
          src="./images/img_82837_0_6.png"
        />
        <img
          v-if="i === 2"
          class="action-bg"
          src="./images/img_82837_0_11.png"
        />
        
        <div class="wrapper-8">
          <div class="wrapper-inner-16">
            <div class="group-8">
              <div class="background-wrapper-8">
                <img class="layer-8" src="./images/img_82837_0_38.png" />
                <img class="background-8" :src="item.web_thumb" />
              </div>
              <img class="entry-pic-8" src="./images/img_82837_0_4.png" />
            </div>
            <div class="button-wrapper-4">
              <span class="button-4">{{ item.describes[1] }}</span>
            </div>
          </div>
          <div class="wrapper-inner-17">
            <span class="title-8">{{ item.title }}</span>
            <span class="caption-8"
              >{{ item.describes[0] }}</span
            >
            <img class="button-bg-8" src="./images/img_82837_0_5.png" />
          </div>
        </div>
      </div>

      <div class="footer">
        <img class="atmosphere-1" src="./images/img_82837_0_64.png" />

        <btn-link />
      </div>
    </div>
  </div>
</template>
<script>
import mixins from "../mixins";
export default {
  mixins: [mixins],
  data() {
    return {
      constants: {},
    };
  },
  methods: {},
};
</script>
<style src="./index.response.css" scoped />
